<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">优惠商品管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="特惠时间段：">
                    <el-select @change="changFindGoods" v-model="timeId" placeholder="时间段">
                        <el-option
                                v-for="item in times"
                                :key="item.id"
                                :label="item.startTime+' - '+item.endTime"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>

                    <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                               @click="submitQuery(1)">刷新
                    </el-button>
                    <el-button type="primary" size="small"
                               @click="$common.goRouterLink({ name: 'discountAddGoods',query:{timeId:timeId} })">
                        在当前时间段添加抢购商品
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>特惠商品列表</span>
        </div>
        <div class="content-data">
            <el-table highlight-current-row
                      :data="goodes" border ref="multipleTable">

                <el-table-column type="index" width="50" label="序号"/>
                <el-table-column align="center" label="名称" prop="goodsName"/>
                <el-table-column align="center" label="原价" prop="goodsPrice"/>
                <el-table-column align="center" label="特惠价" prop="seckillPrice"/>
                <el-table-column align="center" fixed="right" label="操作" width="500px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round
                                   @click="discountGoodsDetail(scope.row.id)">
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <vue-pager v-bind:datafile="fillData" url="seckillGoods/pageByManager" v-bind:query="query" ref="pager"
                   v-bind:init="false"/>
        <div class="content-modal">
            <goods-select ref="goodsSelect" :success="submitQuery"  :goodsId="goodsId" :timeId="timeId" :times="times"/>
        </div>
    </div>
</template>
<script>
    import goodsSelect from './goods-select';

    export default {
        data() {
            return {
                goodes: [],
                times: [],
                query: {},
                dynamicPath: config.hostUrl,
                timeId: '',
                tableTitle: '',
                goodsId: '',
            }
        },
        created() {
            const _this = this;
            _this.findTimes();
        },
        components: {
            goodsSelect,
        },
        methods: {
            discountGoodsDetail(_id) {
                this.goodsId = _id;
                this.$refs.goodsSelect.openDialog();
            },
            fillData(response) {
                this.goodes = response.items || [];
            },
            findTimes() {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillTime/pageSeckillTime',
                    data: {
                        limit: -1,
                    },
                    success(response) {
                        _this.times = response.items || []
                        if (_this.times) {
                            _this.changFindGoods(_this.times[0].id);
                        }
                    }
                })
            },
            submitQuery(_num) {
                const _this = this;
                _this.goods = [];
                _this.$refs.pager.gotoPage(_num);
            },
            changFindGoods(value) {
                const _this = this;
                _this.timeId = value;
                if (_this.timeId) {
                    _this.query.seckillTimeId = _this.timeId;
                }
                _this.submitQuery(1);
            }
        },
    }
</script>
<style scoped>
</style>